export default __webpack_public_path__ + "static/media/Brie.f641cd2a.jpg";